export const MenuIcon = props => (
  <svg
    width={26}
    height={18}
    viewBox='0 0 26 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M1 9H25' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M1 1H25' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M1 17H25' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
